import styled from 'styled-components'

export const AveragePriceWrapper = styled.div.attrs({
  className: 'flex py-24',
})`
  background-color: #fafafa;
  border-radius: 8px;

  & > div {
    flex: 1;
    text-align: center;

    &:not(:last-child) {
      border-right: 1px solid #dddddd;
    }
  }
`
